import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Toast from '../components/Toast';
import FilterableTable from '../components/FilterableTable';

export default function Furnizori() {
  const [furnizori, setFurnizori] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ denumire: '', cui: '', contact: '', telefon: '' });
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);

  function incarca() {
    setLoading(true);
    api.get('/api/furnizori').then(res => setFurnizori(res.data)).finally(() => setLoading(false));
  }

  useEffect(incarca, []);

  function deschideNou() {
    setEditId(null);
    setForm({ denumire: '', cui: '', contact: '', telefon: '' });
    setShowModal(true);
  }

  function deschideEditare(f) {
    setEditId(f.id);
    setForm({ denumire: f.denumire, cui: f.cui || '', contact: f.contact || '', telefon: f.telefon || '' });
    setShowModal(true);
  }

  async function salveaza(e) {
    e.preventDefault();
    try {
      if (editId) await api.put(`/api/furnizori/${editId}`, form);
      else await api.post('/api/furnizori', form);
      setToast({ message: 'Salvat cu succes', type: 'ok' });
      setShowModal(false);
      incarca();
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Eroare la salvare', type: 'error' });
    }
  }

  async function dezactiveaza(id) {
    if (!window.confirm('Dezactivezi acest furnizor?')) return;
    await api.delete(`/api/furnizori/${id}`);
    incarca();
  }

  const coloane = [
    { key: 'denumire', label: 'Denumire' },
    { key: 'cui', label: 'CUI', render: f => f.cui || '-' },
    { key: 'contact', label: 'Contact', render: f => f.contact || '-' },
    { key: 'telefon', label: 'Telefon', render: f => f.telefon || '-' },
    { key: 'actiuni', label: '', filterable: false, render: f => (
      <>
        <button className="btn-edit" onClick={() => deschideEditare(f)}>Editeaza</button>{' '}
        <button className="btn-delete" onClick={() => dezactiveaza(f.id)}>Dezactiveaza</button>
      </>
    )}
  ];

  return (
    <div>
      <h1>Furnizori</h1>
      <div className="toolbar">
        <button className="btn-add" onClick={deschideNou}>+ Adauga</button>
      </div>

      {loading ? <p>Se incarca...</p> : <FilterableTable columns={coloane} rows={furnizori} />}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editId ? 'Editeaza furnizor' : 'Furnizor nou'}</h2>
              <button type="button" className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={salveaza}>
              <div className="modal-body">
                <div className="field">
                  <label>Denumire *</label>
                  <input value={form.denumire} onChange={e => setForm({ ...form, denumire: e.target.value })} required autoFocus />
                </div>
                <div className="field-row">
                  <div className="field">
                    <label>CUI</label>
                    <input value={form.cui} onChange={e => setForm({ ...form, cui: e.target.value })} />
                  </div>
                  <div className="field">
                    <label>Telefon</label>
                    <input value={form.telefon} onChange={e => setForm({ ...form, telefon: e.target.value })} />
                  </div>
                </div>
                <div className="field">
                  <label>Contact</label>
                  <input value={form.contact} onChange={e => setForm({ ...form, contact: e.target.value })} />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn secondary" onClick={() => setShowModal(false)}>Anuleaza</button>
                <button type="submit" className="btn">Salveaza</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
